'use strict';
$(function () {
	let UTIL = {
		init: {
			common: function (type) {
				UTIL.init.presentations();
				// UTIL.init.photoSlider(); выпилили, бо по функционалу то же самое, что презентации, и гораздо более путано реализованы в силу исторических причин
				UTIL.init.liveCharts();
			},
			// PresentatION - интерактивные презентации, включаемые на страницу из визуального редактора
			presentations: function () {
				window.Pion = {
					init: function () {
						Pion.$holderz = $('.pion_holder');
						if (Pion.$holderz.length !== 0) {
							$('head').append('<link rel="stylesheet" href="/st/inex-website/dist/styles/presentation.css"/>');
							Pion.getScripts();
						}
					},

					construct: function ($container) {
						let that = this;
						that.cont = $container;
						that.panelsWrap = that.cont.find('.sliderkit-panels'); // обёртка всех слайдов
						that.panelz = that.panelsWrap.find('.sliderkit-panel'); // обёртки одного слайда
						that.nav = that.cont.find('.sliderkit-nav'); // меню навигации

						that.bindTrigger = function () {
							that.cont.find('.sliderkit-navTrigger').on('click', function (evt) {
								that.navToggle();
								document.querySelector('.sliderkit-navTrigger').classList.toggle('active');
							});

							$(document).keydown(function (e) {
								if (e.keyCode == 27) {
									that.navToggle();
									document.querySelector('.sliderkit-navTrigger').classList.toggle('active');
								}
								if (e.keyCode == 37) {
									// left
									that.cont.find('.sliderkit-go-prev').click();
								}
								if (e.keyCode == 39) {
									// right
									that.cont.find('.sliderkit-go-next').click();
								}
							});
						};
						that.bindTriggerFull = function () {
							that.cont.find('.sliderkit-go-full').on('click', function () {
								$(this).toggleClass('active');
								$('body').toggleClass('fullscreen_body');
								$(this).parents('.pion_holder').toggleClass('pion_holder-fixed');
							});
						};
						that.navToggle = function (e) {
							that.nav.toggle();
						};
						that.init = function () {
							that.cont.sliderkit(that.skparams); // инициализируем слайдшоу
							that.bindTrigger(); // бинд показа/скрытия оглавления
							that.bindTriggerFull(); // бинд показа/скрытия на весь экран
							that.cont.addClass('sliderkit-loaded'); // показываем прежде скрытое содержимое презентации
						};
						that.skparams = {
							// УМОЛЧАТЕЛЬНЫЕ параметры слайдеркита
							auto: false, // автопрокрутка по умолчанию
							autospeed: (that.panelsWrap.data('custom_speed') || 5) * 1000, // скорость автопрокрутки. По умолчанию - 5 секунд
							tabs: 1, // "содержание"
							circular: 1, // бесконечная прокрутка,
							counter: true,
							panelfx: 'sliding', // эффект переключения слайдов
							panelfxeasing: 'easeInOutExpo', // easing type
							panelfxafter: function () {
								// PIRS-3834
								let currSK = that.cont.data('sliderkit');
								if (!!currSK && currSK.currId === 0) {
									// при первичной инициализации слайдера currSK не упевает быть назначенным
									currSK.autoScrollStop();
									currSK.playBtnPause();
								}
							},
						};
					},
					start: function ($container) {
						// Инициализация презентаций
						const pionz = []; // было var pionz = pionz || []; (WTF? ещё и глоб переменная бывает?)
						let $whereToApply = $container ? $container : $; // если передаётся контейнер - ищем в нём. Если нет - применяем ко всем элементам ($ означает document).
						// console.log($whereToApply, $whereToApply.find('.sliderkit'));
						$($whereToApply.find('.sliderkit')).each(function (i) {
							pionz.push(new Pion.construct($(this)));
							pionz[i].init();
						});
						if ($container && $container.html().toString().length == 6) {
							$container.hide();
						}
					},
					getScripts: function () {
						// Получение необходимых скриптов
						let scriptz = [
							'/st/js/jquery.easing.1.3.min.js',
							'/st/js/jquery.sliderkit.1.9.2.pack.js',
							'/st/js/sliderkit.counter.1.0.pack.js',
							'/st/js/jquery.waitforimages.min.js',
						];

						let scriptz_cnt = 0;
						for (let i = 0; i <= scriptz.length; i++) {
							$.get(scriptz[i], function (data) {
								//window["eval"](data);
								scriptz_dispatch();
							});
							$.getScript('/st/js/sliderkit.counter.1.0.pack.js');
						}
						let scriptz_dispatch = function () {
							scriptz_cnt++;
							if (scriptz_cnt === scriptz.length) {
								// все необходимые скрипты загружены
								if (window.PAGEDATA.page_id !== 68650) {
									Pion.getMarkup();
								}
							}
						};
					},
					getMarkup: function () {
						let urlParams = '';
						let pathName = '/' + window.PAGEDATA.lang + '/' + window.PAGEDATA.nav_id + '/page/5642'; // PIRS2018-765
						let pion_card_url = location.protocol + '//' + location.host + pathName + '?layer_name=Pion_card'; // АХТУНГ! имя слоя зашито!
						// console.log('pathName', pathName);

						Pion.$holderz.each(function (i) {
							// первый раз проходимся по холдерам, наполняя параметры запроса
							let H = Pion.$holderz.eq(i);
							$.get(pion_card_url + '&id=' + Pion.$holderz.eq(i).data('pion_id'), function (data) {
								let $data = $(data);
								let $pion_markup = $data.find('.sliderkit').filter('[data-pion_id=' + H.data('pion_id') + ']');
								let $tar_markup = $data.find('.tar').filter('[data-pion_id=' + H.data('pion_id') + ']');
								let $name_markup = $data.find('.pb-card-nameBlock');

								if (!$pion_markup.length) {
									H.addClass('pion_empty');
								}

								H.append($name_markup)
									.append($pion_markup)
									.append($tar_markup)
									.addClass('pion_holder-loaded')
									.waitForImages(function () {
										Pion.start($(this)); // по окончанию загрузки картинок инициализируем презентацию
									});
							});
						});
					},
				};

				// в UI-kit инициализируем по факту подгрузки) {
				Pion.init();
			},
			// Живые графики, включаемые на страницу из визуального редактора
			liveCharts: function () {
				var $liveCharts = $('.livecharts_holder');
				if ($liveCharts.length !== 0) {
					$.getScript('/st/js/live-charts.js')
						.success(function () {
							window.LCH.initFront($liveCharts);
						})
						.error(function () {
							console.log('Ошибка получения или парсинга скрипта live-charts.js');
						});
				}
			},
		},
	};

	if (typeof window !== 'undefined') {
		if (!window.UTIL) {
			window.UTIL = UTIL;
		} else {
			window.UTIL = $.extend(window.UTIL, UTIL);
		}
		UTIL = window.UTIL;
	}
	if (typeof define === 'function' && define.amd) {
		define(UTIL);
	}
	window.UTIL.init.common();
});
